<div class="ds-accent"></div>

<section class="catalogo">
    <div class="catalogo__inner">
        <header class="catalogo__head">
            <div class="catalogo__titulo">
                <span class="material-icons">assignment</span>
                <h1>Trámites disponibles</h1>
            </div>

            <div class="catalogo__buscador">
                <span class="material-icons">search</span>
                <input
                    type="text"
                    [(ngModel)]="textoFiltro"
                    (ngModelChange)="filtrar()"
                    placeholder="Buscar trámite..."
                    aria-label="Buscar trámite"
                />
            </div>
        </header>

        <div class="catalogo__grid" *ngIf="flagLoaded; else skeleton">
            <button
                type="button"
                class="tramite-card ds-card ds-card--interactive"
                *ngFor="let actividad of actividadesFiltradas; trackBy: trackByActividad"
                (click)="seleccionar(actividad)"
            >
                <span class="tramite-card__icono">
                    <span class="material-icons">{{ iconoActividad(actividad) }}</span>
                </span>

                <span class="tramite-card__nombre">{{ actividad.nombre }}</span>

                <span class="tramite-card__resumen" *ngIf="actividad.resumenAvatar">
                    {{ actividad.resumenAvatar }}
                </span>

                <span class="tramite-card__cta">
                    Iniciar
                    <span class="material-icons">arrow_forward</span>
                </span>
            </button>

            <div class="ds-empty" *ngIf="actividadesFiltradas.length === 0">
                <span class="material-icons">search_off</span>
                <p>No encontramos trámites con ese nombre</p>
            </div>
        </div>

        <ng-template #skeleton>
            <div class="catalogo__grid">
                <div class="tramite-card tramite-card--skeleton ds-card" *ngFor="let item of skeletonItems">
                    <span class="ds-skeleton ds-skeleton--icono"></span>
                    <span class="ds-skeleton ds-skeleton--titulo"></span>
                    <span class="ds-skeleton ds-skeleton--texto"></span>
                </div>
            </div>
        </ng-template>
    </div>
</section>
